import { useFixOverlayScroll } from '@/utils/fixOverlayScroll';
import { classnames } from '@/utils/tools';
import React from 'react';
import './UIModal.scss';

export interface UIModalProps {
  onMaskClick?(): void;
  onFooterClick?(selectValue: {
    value: string;
    type?: 'primary';
  }): void;
  className?: string;
  footer: {
    value: string;
    type?: 'primary';
  }[];
  title: any;
  content: any;
}

export default function UIModal(props: UIModalProps) {
  const {
    onMaskClick,
    onFooterClick,
    footer,
    title,
    content,
    className,
  } = props;

  const ref = useFixOverlayScroll();

  return (
    <div ref={ref} className={classnames('ui-modal', className)} onClick={(e) => {

      if (e.target !== e.currentTarget) {
        return;
      }
      onMaskClick?.();
    }}>

      <div className="container">
        {
          title && <h1 className="title">{title}</h1>
        }
        {content}
        <div className="footer">
          {
            footer.map((item, index) => (
              <React.Fragment key={item.value}>
                {index !== 0 && <div className="gap"></div>}
                <div className={classnames('item', { primary: item.type === 'primary' })} onClick={() => {
                  onFooterClick?.(item);
                }}>{item.value}</div>
              </React.Fragment>
            ))
          }
        </div>
      </div>
    </div>
  );
}

export { };
